'use strict';

module.exports = require('./Tooltip');


/*****************
 ** WEBPACK FOOTER
 ** ./~/._rc-tooltip@3.4.2@rc-tooltip/lib/index.js
 ** module id = 645
 ** module chunks = 0 1
 **/